import React from 'react';
import { connect } from 'react-redux';

import { RootState } from 'src/reducers';
import {
  selectCurrentPlan,
  selectProPlan,
} from 'src/app/subscription/subscription-reducer';
import { selectIsLoggedIn } from 'src/common/state/me/me-selectors';
import { videoPrivacyActions } from 'src/dashboard/state/video-privacy/video-privacy-actions';
import {
  selectVideoPrivacyAllowedDomainHasSaved,
  selectVideoPrivacyAllowedDomainIsSaving,
  selectVideoPrivacyModalIsShowing,
  selectVideoPrivacyResetModalIsResetting,
  selectVideoPrivacyResetModalIsShowing,
} from 'src/dashboard/state/video-privacy/video-privacy-selectors';
import { selectVideoForPrivacyModal } from 'src/dashboard/state/videos/videos-selectors';
import { VideoPrivacyModalComponent } from './video-privacy-modal-component';

const mapStateToProps = (state: RootState) => ({
  currentPlan: selectCurrentPlan(state),
  proPlan: selectProPlan(state),
  hasAllowedDomainSaved: selectVideoPrivacyAllowedDomainHasSaved(state),
  isAllowedDomainSaving: selectVideoPrivacyAllowedDomainIsSaving(state),
  isLoggedIn: selectIsLoggedIn(state),
  isResetModalShowing: selectVideoPrivacyResetModalIsShowing(state),
  isResetModalResetting: selectVideoPrivacyResetModalIsResetting(state),
  isShowing: selectVideoPrivacyModalIsShowing(state),
  video: selectVideoForPrivacyModal(state),
});

const mapDispatchToProps = {
  handleAllowDownloadToggle:
    videoPrivacyActions.videoPrivacyModal.playerPreferencesSection.allowDownload
      .toggled,
  handleAllowedDomainChange:
    videoPrivacyActions.videoPrivacyModal.restrictionSection.allowedDomainInput
      .changed,
  handleAllowSharingToggle:
    videoPrivacyActions.videoPrivacyModal.playerPreferencesSection.allowSharing
      .toggled,
  handleDomainRestrictionsToggle:
    videoPrivacyActions.videoPrivacyModal.restrictionSection.domainRestrictions
      .toggled,
  handleTurnOffPasswordProtection:
    videoPrivacyActions.videoPrivacyModal.restrictionSection.passwordProtection
      .turnedOff,
  handleResetModalCancelClick:
    videoPrivacyActions.videoPrivacyModal.resetModal.cancelClicked,
  handleResetModalConfirmClick:
    videoPrivacyActions.videoPrivacyModal.resetModal.confirmClicked,
  handleResetSettingsClick:
    videoPrivacyActions.videoPrivacyModal.advanced.resetSettingsClicked,
  handleVisibilityChange:
    videoPrivacyActions.videoPrivacyModal.privacySection.visibility.changed,
  handlePasswordSubmit:
    videoPrivacyActions.videoPrivacyModal.restrictionSection.setPasswordButton
      .clicked,
  onClose: videoPrivacyActions.videoPrivacyModal.closed,
  openChangeCurrentPlanModal:
    videoPrivacyActions.videoPrivacyModal.restrictionSection.domainRestrictions
      .upsellClicked,
  handleFirstRender: videoPrivacyActions.videoPrivacyModal.firstRendered,
};

export const VideoPrivacyModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoPrivacyModalComponent);
